export enum DocumentOperationOrigin {
  FACTORING = 'FACTORING',
  CONFIRMING = 'CONFIRMING',
}

export interface DocumentToEdit {
  id: string;
  folio?: string;
  stakeholderIdentifier?: string;
  businessIdentifier?: string;
  subType?: string;
  issuedDate?: string | Date;
  amount?: number;
  dueDate?: string | Date;
}

export interface EditDocumentsInput {
  documents: DocumentToEdit[];
  origin?: DocumentOperationOrigin;
}

export interface EditDocumentsOutput {
  updatedDocuments: Array<{
    id: string;
    stakeholderIdentifier: string;
    businessIdentifier: string;
    subType: string | null;
    issuedDate: string; // ISO date string
    amount: number;
    dueDate?: string; // ISO date string
  }>;
  errors: Array<{
    documentId: string;
    error: string;
  }>;
}
